export default __webpack_public_path__ + "static/media/icon_drills_undrilled.7b576571.png";